function same(a, b) {
  if (a === b) {
    return true;
  }
  var sameId = a.id === b.id;
  var sameLabel = a.label === b.label;
  var sameType = a.type === b.type;
  return sameId && sameLabel && sameType;
}
function sameOrder(a, b) {
  if (a === b) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (var i = 0; i < a.length; i++) {
    if (!same(a[i], b[i])) {
      return false;
    }
  }
  return true;
}

export { sameOrder };
//# sourceMappingURL=same-order.esm.js.map
